export default "__VITE_ASSET__BlgBK_$G__"